import { ConditionResult } from "types/Models/ruleEngine";
import { AMOUNT_RANGE_ERROR } from "constants/ruleEngine";
import { getInvalidRuleAmountRangeRows } from "utils/getInvalidRuleAmountRangeRows";
import { array, mixed, object, string } from "yup";

const NO_CONDITIONS: ConditionResult[] = [];

const notRequired = {
  field: string().notRequired(),
  conditionFunction: string().notRequired(),
  conditionValue: mixed().oneOf([
    string().notRequired(),
    array().notRequired(),
  ]),
};

const required = {
  field: string().required(" "),
  conditionFunction: string().required(" "),
  conditionValue: mixed().required(" "),
};

export const categorisationRuleSchema = (
  conditions: ConditionResult[] = NO_CONDITIONS
) =>
  object({
    ruleConditionData: array()
      .of(
        object().when({
          is: (value: Record<string, string>) => {
            return Object.entries(value).every(
              ([key, value]) => !Boolean(value)
            );
          },
          then: object(notRequired),
          otherwise: object(required),
        })
      )
      .test(
        "amount-range",
        AMOUNT_RANGE_ERROR,
        (rows) =>
          getInvalidRuleAmountRangeRows(conditions, rows || []).length === 0
      ),
    assigned_category_id: string().nullable(),
    assigned_vendor_id: string().nullable(),

    classification_ids: array().of(string()).nullable(),
    priority: string().required("Please select priority"),
    startDate: string().when("transactionsFor", {
      is: "custom",
      then: string().required("Please select date").nullable(),
      otherwise: string().notRequired().nullable(),
    }),
    endDate: string().when("transactionsFor", {
      is: "custom",
      then: string().required("Please select date").nullable(),
      otherwise: string().notRequired().nullable(),
    }),
    transactionsFor: string().required("Please select date"),
    name: string().required("Please enter rule name"),
  });

export const editCategorisationRuleSchema = (
  conditions: ConditionResult[] = NO_CONDITIONS
) =>
  object({
    ruleConditionData: array()
      .of(
        object().when({
          is: (value: Record<string, string>) => {
            return Object.entries(value).every(([key, value]) =>
              key === "uuid" ? true : !Boolean(value)
            );
          },
          then: object(notRequired),
          otherwise: object(required),
        })
      )
      .test(
        "amount-range",
        AMOUNT_RANGE_ERROR,
        (rows) =>
          getInvalidRuleAmountRangeRows(conditions, rows || []).length === 0
      ),
    startDate: string().notRequired().nullable(),
    endDate: string().notRequired().nullable(),
    name: string().required("Please enter rule name"),
    assigned_category_id: string().nullable(),
    assigned_vendor_id: string().nullable(),

    classification_ids: array().of(string()).nullable(),
    priority: string().required("Please select priority"),
  });
